// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"24837d2c","450":"3b964d4d","787":"f93ebbab","963":"32f00b4c"}[chunkId] + ".chunk.js";
};